export const NONE: string = 'None';
export const UNCATEGORIZED: string = 'uncategorized';

export enum ApprovalStatus {
	APPROVED = 'Approved',
	PENDING_APPROVAL = 'PendingApproval',
	PENDING_PROCESSING = 'PendingProcessing', // when video is processing (transcoding, transcribing, metadatagen, etc.) before approval can be granted
	REJECTED = 'Rejected',
	REQUIRES_APPROVAL = 'RequiresApproval'
}

export enum ApprovalStepStatus {
	APPROVED = 'Approved',
	PENDING = 'Pending',
	REJECTED = 'Rejected'
}

export enum AccessControl {
	Private = 'Private',
	Public = 'Public',
	AllUsers = 'AllUsers'
}
